











































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { ApiV2Service } from '../../services/api.base.service';
import { getDeviceImage } from '@/classes/images';
import FileUpload from '@/components/FileUpload.vue';
import { Cropper } from 'vue-advanced-cropper';
import '../../classes/blob.image.convert';
import GenericButton from '@/components/GenericButton.vue';
import SimService from '@/services/sim.service';

@Component({
  components: {
    GenericButton,
    FileUpload,
    Cropper,
  },
})
export default class AdmingatewayTypeDetails extends Vue {
  @Getter private useGatewaySubscriptions!: boolean;
  @Getter private hasPermission: any;
  private menu: object[] = [
    { title: 'Device Type Details', path: ''},
    { title: 'Edit Mapping Function', path: 'organisation_settings'},
    { title: 'Edit Downlink Function', path: 'billing' },
    { title: 'Edit Data Schema', path: 'billing' },
    { title: 'Edit Configuration Profiles', path: 'billing' },
    { title: 'Edit Event Rules', path: '/rules' },
  ];

  @Prop({default: {}}) private gatewayType: any;
  @Prop() private logo!: Blob | null;

  private formFactors: any[] = [];

  private logoData: any = {};
  private logoCopy: Blob | null = null;
  private croppedLogo: Blob | null = null;
  private saveImage: boolean = false;
  private showCropper: boolean = false;

  private async mounted() {
    const gatewayImage = this.gatewayImage();
    this.logoCopy = this.logo;

    if (gatewayImage.length) {
      this.logoCopy = await ApiV2Service.getBlobExt(gatewayImage, {ignoreErrors: true, crossDomain: true});
    }

    this.logoData = {
      logo: this.logoCopy,
      croppedLogo: this.croppedLogo,
      saveImage: this.saveImage,
      showCropper: this.showCropper,
    };

    await Promise.all([
      this.getFormFactors(),
    ]);
  }

  private async getFormFactors() {
    const formFactors = await SimService.getFormFactors();
    Vue.set(this, 'formFactors', formFactors);
  }

  private gatewayImage() {
    if (this.gatewayType && this.gatewayType.slug) {
      return getDeviceImage(this.gatewayType);
    } else {
      return '';
    }
  }

  private get getLogoSrc(): string {
    let src = '';
    if (this.logoCopy) {
      src = URL.createObjectURL(this.logoCopy);
    }
    return src;
  }

  private removeLogo(): void {
    this.saveImage = true;
    this.logoCopy = null;

    Vue.set(this.logoData, 'logo', this.logoCopy);
    Vue.set(this.logoData, 'saveImage', this.saveImage);
  }

  private async addLogo(file: any): Promise<void> {
    this.saveImage = true;
    this.logoCopy = file.files[0];

    Vue.set(this.logoData, 'logo', this.logoCopy);
    Vue.set(this.logoData, 'saveImage', this.saveImage);
  }

  private async onCropperChange(event: any) {
    const canvas: HTMLCanvasElement = event.canvas;
    await (new Promise((res, reject) =>
        canvas.toBlob((blob: Blob | null) => {
          this.croppedLogo = blob;
        }, 'image/png'),
    ));

    Vue.set(this.logoData, 'croppedLogo', this.croppedLogo);

  }

  private getImageSize(event: any) {
    this.showCropper = event.target.height !== event.target.width;
    Vue.set(this.logoData, 'showCropper', this.showCropper);

    if (!this.showCropper) {
      event.target.style.visibility = 'visible';
    }
  }
}
